// extracted by mini-css-extract-plugin
module.exports = {"footerFrame":"BrandFooter--footerFrame--2fNcm","footerIcon":"BrandFooter--footerIcon--1D4pp","footerText":"BrandFooter--footerText--3X2EC"};